/**
 * Community Guidelines / Communityregler
 * Source: /Information/Terms/community_guidelines_v1_*.md
 */

export const communityGuidelinesSV = `# Community Guidelines – Beredskapshubben

**Senast uppdaterad: 2026-03-07**

Beredskapshubben är en plattform för samarbete och kunskapsdelning kring hemberedskap. För att skapa en trygg och tillförlitlig miljö gäller dessa communityregler för alla användare.

Genom att delta i grupper, chattar och diskussioner accepterar du dessa riktlinjer.

---

## Syfte

Communityt ska vara:

- tryggt
- sakligt
- hjälpsamt
- respektfullt
- säkerhetsfrämjande

---

# Tillåtet innehåll

Du får gärna dela:

- beredskapstips
- erfarenheter
- checklistor
- praktiska lösningar
- frågor och svar
- konstruktiva diskussioner
- verifierbara källor
- tydligt markerade egna bedömningar

---

# Förbjudet innehåll

Följande är inte tillåtet:

## Skadligt beteende
- hot eller trakasserier
- hat eller diskriminering
- personangrepp
- mobbning

---

## Farlig information
- instruktioner för våld eller sabotage
- hur man skadar människor eller samhällsfunktioner
- operativa säkerhetssvagheter
- taktik för att kringgå lag eller myndigheter

---

## Kris- och säkerhetsmissbruk
- falska larm
- medvetet felaktig krisinformation
- rykten presenterade som fakta
- utge sig för att vara myndighet
- spela expert utan att ange osäkerhet

---

## Integritetsintrång
- dela andras personuppgifter
- publicera adresser eller kontaktuppgifter
- doxxning
- dela privat gruppinnehåll externt

---

## Olagligt eller otillåtet
- olagligt material
- upphovsrättsintrång
- försäljning utan tillstånd
- spam och reklam
- bedrägeriförsök

---

# Beredskapsinformation – särskild regel

När du delar råd:

- var tydlig om det är personlig åsikt
- ange källa när möjligt
- markera osäkerhet
- undvik absoluta påståenden
- hänvisa till myndigheter vid kris

---

# Gruppregler

Gruppadministratörer får:

- sätta kompletterande regler
- moderera innehåll
- ta bort inlägg
- utesluta medlemmar

Gruppregler får inte strida mot plattformens regler.

---

# Missbruk av rapporteringssystem

Det är inte tillåtet att:

- massrapportera utan grund
- rapportera för att tysta åsikter
- missbruka modereringsverktyg

---

# Moderering

Vi kan:

- ta bort innehåll
- begränsa synlighet
- varna användare
- stänga av konton
- ta bort grupper

Detta kan ske utan förvarning vid allvarliga överträdelser.
När det är möjligt informerar vi om skälen och hur du kan kontakta support för omprövning.

---

# Rapportera innehåll

Rapportera innehåll som bryter mot reglerna via:

- rapporteringsknapp
- gruppadmin
- support

Vi granskar rapporter så snabbt som möjligt.

---

# Påföljder

Överträdelse kan leda till:

- varning
- borttaget innehåll
- tillfällig avstängning
- permanent avstängning

Allvarliga fall kan rapporteras till myndighet.

---

# Bra community-beteende

Vi uppmuntrar:

- källhänvisning
- saklighet
- respekt
- tydlighet
- hjälpsamhet
- ansvarstagande

---`;

export const communityGuidelinesEN = `# Community Guidelines – Beredskapshubben

**Last updated: 2026-03-07**

Beredskapshubben is a collaboration and knowledge-sharing platform for household preparedness. To maintain a safe and trustworthy environment, all users must follow these community guidelines.

By participating in groups and discussions, you agree to these rules.

---

## Purpose

The community should be:

- safe  
- factual  
- supportive  
- respectful  
- security-minded

---

# Allowed Content

You are encouraged to share:

- preparedness tips  
- practical experiences  
- checklists  
- solutions  
- questions and answers  
- constructive discussion  
- verifiable sources  
- clearly labeled personal opinions

---

# Prohibited Content

## Harmful Behavior
- threats or harassment  
- hate or discrimination  
- personal attacks  
- bullying

---

## Dangerous Information
- violence or sabotage instructions  
- how to harm people or infrastructure  
- operational security weaknesses  
- evasion of law enforcement

---

## Crisis & Safety Misuse
- false alarms  
- knowingly false crisis information  
- rumors presented as facts  
- impersonating authorities  
- false expert claims

---

## Privacy Violations
- sharing personal data of others  
- posting addresses/contact details  
- doxxing  
- sharing private group content externally

---

## Illegal or Unauthorized
- illegal material  
- copyright violations  
- unauthorized sales  
- spam or advertising  
- fraud attempts

---

# Preparedness Advice Rule

When giving advice:

- state if it is personal opinion  
- cite sources when possible  
- note uncertainty  
- avoid absolute claims  
- refer to official authorities in crises

---

# Group Rules

Group administrators may:

- add additional rules  
- moderate content  
- remove posts  
- remove members

Group rules may not conflict with platform rules.

---

# Reporting Abuse

You may not:

- mass-report without cause  
- weaponize reporting  
- misuse moderation tools

---

# Moderation

We may:

- remove content  
- limit visibility  
- warn users  
- suspend accounts  
- remove groups

This may occur without prior notice for serious violations.
Where possible, we inform you of the reasons and how to contact support for review.

---

# Reporting Content

Report violations via:

- report button  
- group admin  
- support

We review reports as quickly as possible.

---

# Enforcement

Violations may result in:

- warning  
- content removal  
- temporary suspension  
- permanent ban

Serious cases may be reported to authorities.

---

# Good Community Behavior

We encourage:

- citing sources  
- factual tone  
- respect  
- clarity  
- helpfulness  
- responsibility

---`;
